import axios from 'axios';
import { ApplicationPaths, QueryParameterNames } from '../components/api-authorization/ApiAuthorizationConstants';
import authService from '../components/api-authorization/AuthorizeService';
import history from '../history';

const instance = axios.create({
    //baseURL: "api/v1"//process.env.ApiBaseUrl
});

// Request interceptor: adjunta Bearer token
instance.interceptors.request.use(async function (config) {
    const token = await authService.getAccessToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

// Response interceptor: ante un 401 intenta renovar el token y reintentar el request
// original una sola vez (evita perder datos de requests en vuelo por una renovación
// que compitió con otras y falló de forma espuria). Si la renovación falla de verdad
// (sesión real expirada), recién ahí redirige al login preservando la URL actual.
// En 403 no redirige ni limpia el centro activo: un error de permiso no implica que el
// centro sea inválido. La validez del centro se verifica en el bootstrap al iniciar
// sesión. Los componentes muestran el error vía HandleApiError.
instance.interceptors.response.use(response => {
    return response;
}, async error => {
    const { config, response } = error;

    if (response?.status === 401) {
        if (config && !config._retry) {
            config._retry = true;
            const renewedUser = await authService.renewAccessToken();
            if (renewedUser?.access_token) {
                config.headers.Authorization = `Bearer ${renewedUser.access_token}`;
                return instance(config);
            }
        }

        // Ya se reintentó (o no había config para reintentar) y sigue en 401: la sesión
        // está realmente vencida/ inválida, no fue una falla espuria de renovación.
        history.push(
            `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(window.location.href)}`
        );
    }

    return Promise.reject(error);
});

export default instance;